import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);
import { SplitText } from 'gsap/SplitText.js'
gsap.registerPlugin(SplitText);


class Pin extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.index = 0

     this.ref = {
       retail: null,
       connect: null,
       trigger: null, 
       stick: null,
       contact: null
     }

     

   

  }

  mount() {

    const timeDisplay = document.querySelectorAll('.time');
    const timeZones = ["Europe/London", "America/New_York", "America/Los_Angeles"];

    for (let i = 0; i < timeDisplay.length; i++) {
      setInterval(function () {
        // Function passed in will run at interval defined below (creates a 'tick')

        let time = new Date();
        // Creates new Date object

        time = time.toLocaleTimeString("en-US", {
          timeZone: timeZones[i],
          hour: '2-digit',
          minute: '2-digit'
        });
        // Sets time format to "en-US" timezone to i in array

        timeDisplay[i].innerText = time
        // Set this to be the displayed time in time display element i

      }, 1000);
      // Time updated every 1000 milliseconds (i.e. every second)
    }

    

    ScrollTrigger.create({
      trigger: this.ref.contact,
      start: "bottom bottom",
      endtrigger: this.ref.stick,
      end: "top top",
      pin: true,
      pinSpacing: false, 
      invalidateOnRefresh: true // to make it responsive
    });

  
   
    ScrollTrigger.create({
      trigger: this.ref.contact,
      start: "top+=50% 50%",
      end: "bottom bottom-=500%",
      pin: true,
      pinSpacing: false,
      pinType: "transform",
      invalidateOnRefresh: true // to make it responsive
    });  
    
}


  unmount() {




  }


}

module.exports = Pin
